import { Permission } from "@/types/auth";

// RBAC Permissions based on actual application routes
export const MOCK_PERMISSIONS: Permission[] = [
  // Dashboard
  {
    id: "dashboard_view",
    name: "View Dashboard",
    resource: "dashboard",
    action: "view",
    description: "Access main dashboard with statistics and analytics",
    category: "Dashboard",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // User Management - Users
  {
    id: "users_view",
    name: "View Users",
    resource: "users",
    action: "view",
    description: "View list of users and their details",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "users_create",
    name: "Create Users",
    resource: "users",
    action: "create",
    description: "Add new users to the system",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "users_edit",
    name: "Edit Users",
    resource: "users",
    action: "edit",
    description: "Modify user information and settings",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "users_delete",
    name: "Delete Users",
    resource: "users",
    action: "delete",
    description: "Remove users from the system",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "users_activate",
    name: "Activate/Deactivate Users",
    resource: "users",
    action: "activate",
    description: "Enable or disable user accounts",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "users_reset_password",
    name: "Reset User Password",
    resource: "users",
    action: "reset_password",
    description: "Reset passwords for users",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // User Management - Roles
  {
    id: "roles_view",
    name: "View Roles",
    resource: "roles",
    action: "view",
    description: "View list of roles and their permissions",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "roles_create",
    name: "Create Roles",
    resource: "roles",
    action: "create",
    description: "Create new roles with permissions",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "roles_edit",
    name: "Edit Roles",
    resource: "roles",
    action: "edit",
    description: "Modify role names and permissions",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "roles_delete",
    name: "Delete Roles",
    resource: "roles",
    action: "delete",
    description: "Remove roles from the system",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "roles_assign",
    name: "Assign Roles to Users",
    resource: "roles",
    action: "assign",
    description: "Assign roles to users",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // User Management - Permissions
  {
    id: "permissions_view",
    name: "View Permissions",
    resource: "permissions",
    action: "view",
    description: "View all system permissions",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "permissions_manage",
    name: "Manage Permissions",
    resource: "permissions",
    action: "manage",
    description: "Full control over permissions management",
    category: "User Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Config Management - Countries
  {
    id: "countries_view",
    name: "View Countries",
    resource: "geography",
    action: "view_countries",
    description: "View list of countries",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "countries_create",
    name: "Create Countries",
    resource: "geography",
    action: "create_countries",
    description: "Add new countries to the system",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "countries_edit",
    name: "Edit Countries",
    resource: "geography",
    action: "edit_countries",
    description: "Modify country information",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "countries_delete",
    name: "Delete Countries",
    resource: "geography",
    action: "delete_countries",
    description: "Remove countries from the system",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Config Management - States
  {
    id: "states_view",
    name: "View States",
    resource: "geography",
    action: "view_states",
    description: "View list of states/provinces",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "states_create",
    name: "Create States",
    resource: "geography",
    action: "create_states",
    description: "Add new states/provinces",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "states_edit",
    name: "Edit States",
    resource: "geography",
    action: "edit_states",
    description: "Modify state information",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "states_delete",
    name: "Delete States",
    resource: "geography",
    action: "delete_states",
    description: "Remove states from the system",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Config Management - Cities
  {
    id: "cities_view",
    name: "View Cities",
    resource: "geography",
    action: "view_cities",
    description: "View list of cities",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "cities_create",
    name: "Create Cities",
    resource: "geography",
    action: "create_cities",
    description: "Add new cities",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "cities_edit",
    name: "Edit Cities",
    resource: "geography",
    action: "edit_cities",
    description: "Modify city information",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "cities_delete",
    name: "Delete Cities",
    resource: "geography",
    action: "delete_cities",
    description: "Remove cities from the system",
    category: "Config Management",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Drivers
  {
    id: "drivers_view",
    name: "View Drivers",
    resource: "drivers",
    action: "view",
    description: "View list of drivers and their details",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "drivers_create",
    name: "Create Drivers",
    resource: "drivers",
    action: "create",
    description: "Add new drivers to the system",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "drivers_edit",
    name: "Edit Drivers",
    resource: "drivers",
    action: "edit",
    description: "Modify driver information and documents",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "drivers_delete",
    name: "Delete Drivers",
    resource: "drivers",
    action: "delete",
    description: "Remove drivers from the system",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "drivers_activate",
    name: "Activate/Deactivate Drivers",
    resource: "drivers",
    action: "activate",
    description: "Enable or disable driver accounts",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "drivers_kyc",
    name: "Manage Driver KYC",
    resource: "drivers",
    action: "manage_kyc",
    description: "Approve or reject driver KYC documents",
    category: "Drivers",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Riders
  {
    id: "riders_view",
    name: "View Riders",
    resource: "riders",
    action: "view",
    description: "View list of riders and their details",
    category: "Riders",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "riders_create",
    name: "Create Riders",
    resource: "riders",
    action: "create",
    description: "Add new riders to the system",
    category: "Riders",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "riders_edit",
    name: "Edit Riders",
    resource: "riders",
    action: "edit",
    description: "Modify rider information",
    category: "Riders",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "riders_delete",
    name: "Delete Riders",
    resource: "riders",
    action: "delete",
    description: "Remove riders from the system",
    category: "Riders",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "riders_activate",
    name: "Activate/Deactivate Riders",
    resource: "riders",
    action: "activate",
    description: "Enable or disable rider accounts",
    category: "Riders",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Vehicle Categories
  {
    id: "vehicles_view",
    name: "View Vehicle Categories",
    resource: "vehicles",
    action: "view",
    description: "View list of vehicle categories",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "vehicles_create",
    name: "Create Vehicle Categories",
    resource: "vehicles",
    action: "create",
    description: "Add new vehicle categories",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "vehicles_edit",
    name: "Edit Vehicle Categories",
    resource: "vehicles",
    action: "edit",
    description: "Modify vehicle category details",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "vehicles_delete",
    name: "Delete Vehicle Categories",
    resource: "vehicles",
    action: "delete",
    description: "Remove vehicle categories",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Base Pricing (merged into Vehicles section)
  {
    id: "pricing_view",
    name: "View Base Pricing",
    resource: "vehicles",
    action: "view_pricing",
    description: "View base pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "pricing_create",
    name: "Create Base Pricing",
    resource: "vehicles",
    action: "create_pricing",
    description: "Add new base pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "pricing_edit",
    name: "Edit Base Pricing",
    resource: "vehicles",
    action: "edit_pricing",
    description: "Modify base pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "pricing_delete",
    name: "Delete Base Pricing",
    resource: "vehicles",
    action: "delete_pricing",
    description: "Remove base pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "pricing_analytics",
    name: "View Pricing Analytics",
    resource: "vehicles",
    action: "analytics",
    description: "Access pricing analytics and reports",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Surge Pricing (merged into Vehicles section)
  {
    id: "surge_view",
    name: "View Surge Pricing",
    resource: "vehicles",
    action: "view_surge",
    description: "View surge pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "surge_create",
    name: "Create Surge Pricing",
    resource: "vehicles",
    action: "create_surge",
    description: "Add new surge pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "surge_edit",
    name: "Edit Surge Pricing",
    resource: "vehicles",
    action: "edit_surge",
    description: "Modify surge pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "surge_delete",
    name: "Delete Surge Pricing",
    resource: "vehicles",
    action: "delete_surge",
    description: "Remove surge pricing rules",
    category: "Vehicles",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Promotions
  {
    id: "promotions_view",
    name: "View Promotions",
    resource: "promotions",
    action: "view",
    description: "View list of promotions",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "promotions_create",
    name: "Create Promotions",
    resource: "promotions",
    action: "create",
    description: "Create new promotional offers",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "promotions_edit",
    name: "Edit Promotions",
    resource: "promotions",
    action: "edit",
    description: "Modify promotional offers",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "promotions_delete",
    name: "Delete Promotions",
    resource: "promotions",
    action: "delete",
    description: "Remove promotional offers",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Referral Campaigns
  {
    id: "referrals_view",
    name: "View Referral Campaigns",
    resource: "referrals",
    action: "view",
    description: "View list of referral campaigns",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "referrals_create",
    name: "Create Referral Campaigns",
    resource: "referrals",
    action: "create",
    description: "Create new referral campaigns",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "referrals_edit",
    name: "Edit Referral Campaigns",
    resource: "referrals",
    action: "edit",
    description: "Modify referral campaigns",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "referrals_delete",
    name: "Delete Referral Campaigns",
    resource: "referrals",
    action: "delete",
    description: "Remove referral campaigns",
    category: "Marketing",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Disputes
  {
    id: "disputes_view",
    name: "View Disputes",
    resource: "disputes",
    action: "view",
    description: "View list of disputes",
    category: "Support",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "disputes_create",
    name: "Create Disputes",
    resource: "disputes",
    action: "create",
    description: "Create new dispute records",
    category: "Support",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "disputes_edit",
    name: "Edit Disputes",
    resource: "disputes",
    action: "edit",
    description: "Modify dispute details",
    category: "Support",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "disputes_resolve",
    name: "Resolve Disputes",
    resource: "disputes",
    action: "resolve",
    description: "Resolve and close disputes",
    category: "Support",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Reports
  {
    id: "reports_view",
    name: "View Reports",
    resource: "reports",
    action: "view",
    description: "Access reports and analytics",
    category: "Reports",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "reports_export",
    name: "Export Reports",
    resource: "reports",
    action: "export",
    description: "Export reports as PDF or Excel",
    category: "Reports",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Audit Logs
  {
    id: "auditlogs_view",
    name: "View Audit Logs",
    resource: "audit",
    action: "view",
    description: "View system audit logs",
    category: "System",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Settings (general)
  {
    id: "settings_view",
    name: "View Settings",
    resource: "settings",
    action: "view",
    description: "Access settings section",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Email Settings
  {
    id: "email_settings_view",
    name: "View Email Settings",
    resource: "settings",
    action: "view_email",
    description: "View email settings configuration",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "email_settings_edit",
    name: "Edit Email Settings",
    resource: "settings",
    action: "edit_email",
    description: "Modify email settings configuration",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // SMS Settings
  {
    id: "sms_settings_view",
    name: "View SMS Settings",
    resource: "settings",
    action: "view_sms",
    description: "View sms settings configuration",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "sms_settings_edit",
    name: "Edit SMS Settings",
    resource: "settings",
    action: "edit_sms",
    description: "Modify sms settings configuration",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Distance & Wait Time Settings
  {
    id: "settings_distance_view",
    name: "View Distance & Wait Settings",
    resource: "settings",
    action: "view_distance",
    description: "View distance and wait time configuration",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    id: "settings_distance_edit",
    name: "Edit Distance & Wait Settings",
    resource: "settings",
    action: "edit_distance",
    description: "Modify distance and wait time settings",
    category: "Settings",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },

  // Security
  {
    id: "security_change_password",
    name: "Change Password",
    resource: "security",
    action: "change_password",
    description: "Change own password",
    category: "Security",
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
];

// Helper function to get permissions grouped by category
export function getPermissionsGroupedByCategory(): Record<string, Permission[]> {
  return MOCK_PERMISSIONS.reduce((acc, permission) => {
    const category = permission.category || "Other";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(permission);
    return acc;
  }, {} as Record<string, Permission[]>);
}

// Helper function to get permissions grouped by resource
export function getPermissionsGroupedByResource(): Record<string, Permission[]> {
  return MOCK_PERMISSIONS.reduce((acc, permission) => {
    if (!acc[permission.resource]) {
      acc[permission.resource] = [];
    }
    acc[permission.resource].push(permission);
    return acc;
  }, {} as Record<string, Permission[]>);
}

// Helper function to get categories
export function getPermissionCategories(): string[] {
  return Array.from(new Set(MOCK_PERMISSIONS.map((p) => p.category || "Other"))).filter(Boolean);
}

// Helper function to get resources
export function getPermissionResources(): string[] {
  return Array.from(new Set(MOCK_PERMISSIONS.map((p) => p.resource)));
}
